import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import styled from "styled-components";
import { ChevronDown } from "react-feather";
import { spacing } from "../../design-system/tokens/spacing";
import { borderRadius, semanticBorderRadius } from "../../design-system/tokens/borders";
import { typographyMixin } from "../../design-system/tokens/typography";
import { zIndex } from "../../design-system/tokens/shadows";
import { popoverMotion } from "../../design-system/tokens/popoverMotion";
import { rawColors } from "../../design-system/tokens/colors";

export const TriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[3]};
  padding: ${spacing[2]} ${spacing[3]} ${spacing[2]} ${spacing[4]};
  background-color: ${rawColors.grey[900]};
  color: ${rawColors.text.white};
  border: ${({ theme }) => theme.borders.width[1]} ${({ theme }) => theme.borders.style.solid} ${({ theme }) => theme.colors.border.subtle};
  border-radius: ${semanticBorderRadius.button.lg};
  cursor: pointer;
  ${typographyMixin("body", 3)}
  transition: ${({ theme }) => theme.transitions.semantic.interactive.button.background},
              ${({ theme }) => theme.transitions.semantic.interactive.button.shadow};

  &:hover:not(:disabled) {
    // background-color: ${rawColors.grey[800]};
  }

  &:focus-visible {
    outline: none;
    box-shadow: ${({ theme }) => theme.shadows.interactive.focus};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ChevronIcon = styled(ChevronDown)<{ $open: boolean }>`
  width: 1em;
  height: 1em;
  flex-shrink: 0;
  transition: ${({ theme }) => theme.transitions.semantic.interactive.button.transform};
  transform: ${({ $open }) => ($open ? "rotate(180deg)" : "rotate(0deg)")};
`;

export const Content = styled(DropdownMenu.Content)`
  background-color: ${rawColors.structural.white};
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.xl};
  box-shadow: 0px 10px 8px 0px rgba(0, 0, 0, 0.04),
    0px 4px 3px 0px rgba(0, 0, 0, 0.1);
  padding: 0 0 ${spacing[2]} 0;
  z-index: ${zIndex.dropdown};
  overflow: hidden;
  &[data-state="open"] {
    ${popoverMotion(false)}
  }
  &[data-state="closed"] {
    ${popoverMotion(true)}
  }
`;

export const Item = styled(DropdownMenu.Item)`
  display: flex;
  align-items: center;
  gap: ${spacing[3]};
  padding: ${spacing[2]} ${spacing[3]};
  margin: ${spacing[2]} ${spacing[2]} 0;
  cursor: pointer;
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.highEmphasis};
  border-radius: ${borderRadius.lg};
  outline: none;
  white-space: nowrap;
  min-width: 115px;

  &[data-highlighted] {
    background-color: ${rawColors.grey[50]};
  }

  &:focus-visible {
    background-color: ${rawColors.grey[50]};
  }
`;
